import { type FC } from "react";
import { Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { Filter, useFilter } from "@/partner/shared/components/Filter";
import { PagePaths } from "@/partner/shared/constants/routes";
import { DownloadReportButton } from "@/partner/features/reports";
import { ReportTypeType } from "@/types/graphql/partner.generated";
import { buildPromocodesFilter } from "../model/buildPromocodesFilter";

interface PromocodesFilterProps {
  onCreate: () => void;
  onCreateMultiple: () => void;
}

/**
 * Карточка фильтра в общем стиле списков кабинета (Users/Videos/Links):
 * поиск и кампании внутри раскрывающейся панели, кнопки в шапке.
 */
export const PromocodesFilter: FC<PromocodesFilterProps> = ({
  onCreate,
  onCreateMultiple,
}) => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  return (
    <Filter
      title={t("promocodes.title")}
      fields={{ search: true, promocodeCampaignIds: true }}
      action={
        <Stack direction="row" spacing={1} alignItems="center">
          <DownloadReportButton
            type={ReportTypeType.PromocodesType}
            filter={
              buildPromocodesFilter(filter) as
                | Record<string, unknown>
                | undefined
            }
          />
          <Button
            variant="outlined"
            component={RouterLink}
            to={`${PagePaths.promocodes}?tab=createMany`}
            disableElevation
            onClick={(event) => {
              event.preventDefault();
              onCreateMultiple();
            }}
          >
            {t("promocodes.addMultiple")}
          </Button>
          <Button
            variant="contained"
            component={RouterLink}
            to={`${PagePaths.promocodes}?tab=create`}
            disableElevation
            onClick={(event) => {
              event.preventDefault();
              onCreate();
            }}
          >
            {t("promocodes.add")}
          </Button>
        </Stack>
      }
    />
  );
};
